// src/App.js
import React, { useState, useEffect } from 'react';
import './App.css';
import CountdownTimer from './components/CountdownTimer';
import PomodoroTimer from './components/PomodoroTimer';
import ProgressBar from './components/ProgressBar';
//import { prioritizeTasks } from './utils/PrioritizeTasks';
import {
  AppBar,
  Toolbar,
  Typography,
  Container,
  Grid,
  Box,
} from '@mui/material';
import ChatGPTAccountabilityBuddy from './ChatGPTAccountabilityBuddy';
import TaskList from './components/TaskList';
import RecommendedTask from './components/RecommendedTask';
import BadgeContainer from './components/BadgeContainer';

// Build a visualisation system, with animations, for a soccer game on a gambling website, using react
const taskData = {
    "subject": "Soccer Match Visualization System for Gambling Website",
    "description": "Develop a soccer match visualization system for a gambling website using React, Framer, and an animation framework. The interface should provide a visual representation of the match and its events in real-time. The match data will be provided by an external API.",
    "acceptanceCriteria": [
      "Real-time visualization of soccer match events",
      "Integration with external match data API",
      "Animations and visual effects to enhance user experience",
      "Responsive design to support various screen sizes"
    ],
    "recommendedStart": {
      "taskId": 7
    },
    "finishedTasks": [],
      "bigTasks": [
        {
          "id": 1,
          "title": "Implement real-time data integration with external API",
          "priority": 1
        },
        {
          "id": 2,
          "title": "Develop soccer field visualization with animations",
          "priority": 2
        },
        {
          "id": 3,
          "title": "Create gambling interface and integrate with visualization",
          "priority": 3
        }
      ],
      "mediumTasks": [
        {
          "id": 4,
          "title": "Design and develop user interface components",
          "priority": 1
        },
        {
          "id": 5,
          "title": "Implement responsive design for different screen sizes",
          "priority": 2
        },
        {
          "id": 6,
          "title": "Develop state management for the application",
          "priority": 3
        }
      ],
      "simpleTasks": [
        {
          "id": 7,
          "title": "Set up the React project",
          "priority": 1
        },
        {
          "id": 8,
          "title": "Choose an animation framework",
          "priority": 2
        },
        {
          "id": 9,
          "title": "Create reusable components for player visualization",
          "priority": 3
        },
        {
          "id": 10,
          "title": "Implement tooltips for player statistics",
          "priority": 4
        }
      ]
  };



/* const TaskList = ({ tasks, onComplete }) => {
  return (
    <ul>
      {tasks.map((task) => (
        <li key={task.id}>
          {task.name}
          <button onClick={() => onComplete(task.id)}>Complete</button>
        </li>
      ))}
    </ul>
  );
}; */

const App = () => {
  // const [tasks, setTasks] = useState([
  //   // Add sample tasks here
  // ]);
  //const [completedTasks, setCompletedTasks] = useState(0);
  const [completedPomodoros, setCompletedPomodoros] = useState(0);
  const [isCountdownComplete, setIsCountdownComplete] = useState(false);
  const [xp, setXp] = useState(0);
  const [level, setLevel] = useState(1);
  const { recommendedStart, bigTasks, mediumTasks, simpleTasks } = taskData;
  const [completedTasks, setCompletedTasks] = useState(0);

  const handleCompletedTasks = (newCompletedTasks) => {
    setCompletedTasks(newCompletedTasks);
    setXp(xp + 50);
  };

  const handleCountdownCompletion = () => {
    setIsCountdownComplete(true);
  };

  const handlePomodoroCompletion = () => {
    setCompletedPomodoros(completedPomodoros + 1);
    // Earn XP for Pomodoro completion
    setXp(xp + 25);
  };

  // Level up logic
  useEffect(() => {
    if (xp >= level * 100) {
      setLevel(level + 1);
      // Reset the XP for the new level
      setXp(0);
    }
  }, [xp, level]);

  const handleCountdownEnd = () => {
    console.log('Countdown ended');
  };

  return (
    <div className="App">
    <AppBar position="static">
      <Toolbar>
        <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
          Focusbuddy
        </Typography>
      </Toolbar>
    </AppBar>
    <Container maxWidth="md">
      <Box sx={{ padding: 4 }}>
          <Grid item xs={20} sm={10}>
            <ChatGPTAccountabilityBuddy />
          </Grid>
          <Typography variant="h6" component="h3" gutterBottom>
            Completed Pomodoros: {completedPomodoros}
          </Typography>
          <Typography variant="h6" component="h3" gutterBottom>
            Level: {level}
          </Typography>
          <Typography variant="h6" component="h3" gutterBottom>
            XP: {xp}
          </Typography>
        <Grid container spacing={4}>
          <Grid item xs={20} sm={10}>
            <Box sx={{ marginBottom: 4 }}>
              <TaskList title="Simple Tasks" tasks={simpleTasks} onCompletedTasks={handleCompletedTasks} completedTasks={completedTasks} />
            </Box>
            <Box sx={{ marginBottom: 4 }}>
              <TaskList title="Medium Tasks" tasks={mediumTasks} onCompletedTasks={handleCompletedTasks} completedTasks={completedTasks}/>
            </Box>
            <Box sx={{ marginBottom: 4 }}>
              <TaskList title="Big Tasks" tasks={bigTasks} onCompletedTasks={handleCompletedTasks} completedTasks={completedTasks}/>
            </Box>
          <ProgressBar completedTasks={completedTasks} totalTasks={5} />

            <RecommendedTask
              taskId={recommendedStart.taskId}
              onCountdownEnd={handleCountdownEnd}
            />
            {!isCountdownComplete ? (
            <CountdownTimer initialSeconds={5} onComplete={handleCountdownCompletion} />
            ) : (
              <PomodoroTimer
                workTime={25 * 60}
                breakTime={5 * 60}
                onPomodoroComplete={handlePomodoroCompletion}
              />
            )}
          </Grid>
        </Grid>
      </Box>
      <BadgeContainer />
    </Container>
  </div>
  );
};


//   return (
//     <div className="App">
//       <h1>Focusbuddy</h1>
//       <ChatGPTAccountabilityBuddy />
//       {!isCountdownComplete ? (
//         <CountdownTimer initialSeconds={5} onComplete={handleCountdownCompletion} />
//       ) : (
//         <PomodoroTimer
//           workTime={25 * 60}
//           breakTime={5 * 60}
//           onPomodoroComplete={handlePomodoroCompletion}
//         />
//       )}

//       {/* Render your prioritized tasks */}
//       <div className="tasks">
//         <h2>Frogs</h2>
//         <TaskList tasks={groupedTasks.frogs} onComplete={handleTaskCompletion} />
//         <h2>Three Tasks</h2>
//         <TaskList tasks={groupedTasks.threeTasks} onComplete={handleTaskCompletion} />
//         <h2>Five Tasks</h2>
//         <TaskList tasks={groupedTasks.fiveTasks} onComplete={handleTaskCompletion} />
//       </div>

//       <Box sx={{ padding: 4 }}>
//         <TaskList title="Big Tasks" tasks={bigTasks} />
//         <TaskList title="Medium Tasks" tasks={mediumTasks} />
//         <TaskList title="Simple Tasks" tasks={simpleTasks} />
//         <RecommendedTask
//           taskId={recommendedStart.taskId}
//           onCountdownEnd={handleCountdownEnd}
//         />
//       </Box>

//       <ProgressBar completedTasks={completedTasks} totalTasks={tasks.length} />
//       <h2>Completed Pomodoros: {completedPomodoros}</h2>
//       <h2>XP: {xp}</h2>
//       <h2>Level: {level}</h2>
//     </div>
//   );
// };

export default App;
